import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('standalone_workflows_1'),
    description: defineMessage('approvalmax_also_enable_ements_sales_quotes_etc'),
    learnMore: defineMessage('learn_more'),
    close: defineMessage('close'),
    tryNow: defineMessage('try_now_for_days'),
    upgradeSubscription: defineMessage('upgrade_a_subscription'),
};
